import HeroSection from './components/HeroSection';
import ExpertiseSection from './components/ExpertiseSection';
import PrinciplesSection from './components/PrinciplesSection';
import ContactSection from './components/ContactSection';

export default function Home() {
  return (
    <main>
      <HeroSection />
      <ExpertiseSection />
      <PrinciplesSection />
      <ContactSection />
    </main>
  );
}